module.exports = __webpack_public_path__ + "img/Johanna.0d636db4.jpeg";